// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore} from 'firebase/firestore'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDU2C3A9jmi5qj_TSMmok7ynnLD8n253WM",
  authDomain: "crud-a58f1.firebaseapp.com",
  projectId: "crud-a58f1",
  storageBucket: "crud-a58f1.appspot.com",
  messagingSenderId: "69179444465",
  appId: "1:69179444465:web:ea31151b6d0b98fb6d6d50"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);